import React from 'react';
export function Header() {
  return <header className="w-full" data-id="element-1">
      {/* Top Bar */}
      <div className="bg-navy text-white text-xs py-2 px-4 flex justify-between items-center font-sans" data-id="element-2">
        <span className="opacity-90" data-id="element-3">Monday, June 8, 2026</span>
        <span className="opacity-90 hidden sm:inline-block" data-id="element-4">
          Independent Energy Reporting Since 2019
        </span>
      </div>

      {/* Masthead */}
      <div className="bg-cream py-8 text-center border-b-[3px] border-double border-navy/30 px-4" data-id="element-5">
        <div className="text-xs tracking-[0.2em] text-gray-500 mb-4 uppercase font-sans font-medium" data-id="element-6">
          Est. 2019 · Volume VII
        </div>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-navy mb-3 tracking-tight" data-id="element-7">
          Energy Independence Journal
        </h1>
        <p className="font-serif italic text-gray-500 text-lg sm:text-xl" data-id="element-8">
          "Illuminating the path to energy freedom"
        </p>
      </div>

      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm" data-id="element-9">
        <div className="max-w-6xl mx-auto px-4 flex space-x-6 sm:space-x-8 h-14 items-center text-sm font-sans" data-id="element-10">
          <a href="#" className="text-navy font-bold border-b-2 border-navy h-full flex items-center" data-id="element-11">
            Home
          </a>
          <a href="#" className="text-gray-600 hover:text-navy h-full flex items-center transition-colors" data-id="element-12">
            Science
          </a>
          <a href="#" className="text-gray-600 hover:text-navy h-full flex items-center transition-colors" data-id="element-13">
            Reviews
          </a>
          <a href="#" className="text-gray-600 hover:text-navy h-full flex items-center transition-colors" data-id="element-14">
            About
          </a>
        </div>
      </nav>
    </header>;
}